(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const setup = () => {
      const header = document.getElementById('header-component');
      if (!header) return;

      const sections = Array.from(document.querySelectorAll('[data-header-theme]'));

      const applyTheme = (theme) => {
        const isLight = theme === 'light';
        header.classList.toggle('header--on-light', isLight);
        header.classList.toggle('header--on-dark', !isLight);
      };

      // Default to dark/white until a section is confirmed to be behind the header.
      applyTheme('dark');

      if (sections.length === 0) return;

      const handleIntersections = (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            applyTheme(entry.target.dataset.headerTheme);
          }
        }
      };

      const headerHeight = header.offsetHeight || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      // Shrink the observer's root to a single-pixel line positioned exactly where the
      // sticky header's bottom edge sits, so "isIntersecting" means "this section is
      // the one currently behind the header" — not merely "on screen somewhere".
      const bottomMargin = Math.max(viewportHeight - headerHeight - 1, 0);

      // IntersectionObserver.observe() reports its *initial* state asynchronously (next
      // frame/microtask), never synchronously. setup() can be called multiple times in
      // quick succession (DOMContentLoaded, document.fonts.ready, window.load below all
      // call it), and each call disconnects the previous observer immediately. If an
      // earlier observer's initial callback was queued but hadn't fired yet when the next
      // setup() call disconnected it, that callback is simply discarded — the header is
      // left on its synchronous 'dark' default forever, even with a perfectly correct
      // marker in place, since nothing ever reruns after the last disconnect. Computing
      // the current section synchronously here, instead of waiting on the observer's own
      // initial report, removes that race entirely; the observer still handles all
      // *subsequent* scroll-driven updates correctly.
      const triggerY = headerHeight;
      const currentSection = sections.find((section) => {
        const rect = section.getBoundingClientRect();
        return rect.top <= triggerY && rect.bottom > triggerY;
      });
      if (currentSection) {
        applyTheme(currentSection.dataset.headerTheme);
      }

      if (window.__headerThemeObserver) {
        window.__headerThemeObserver.disconnect();
      }

      const observer = new IntersectionObserver(handleIntersections, {
        rootMargin: `-${headerHeight}px 0px -${bottomMargin}px 0px`,
        threshold: 0,
      });

      sections.forEach((section) => observer.observe(section));
      window.__headerThemeObserver = observer;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup, { once: true });
    } else {
      setup();
    }

    // The initial setup() call measures header.offsetHeight to build the observer's
    // rootMargin. If custom fonts (Clash Display / Space Mono in the logo/nav) haven't
    // finished loading/swapping in yet at that point, the header can render a few px
    // taller or shorter than its final size with fallback-font metrics — enough to shift
    // the 1px detection line into the wrong section. That produces exactly this bug: the
    // header starts in the wrong on-light/on-dark state and only self-corrects once the
    // user scrolls (the observer is still live and reacts correctly to the *next* scroll
    // position, it just started from a rootMargin computed against the wrong height).
    // Re-running setup() once fonts are confirmed loaded, and again on full page load,
    // rebuilds the observer against the final, accurate header height without requiring
    // any user interaction first.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setup);
    }
    window.addEventListener('load', setup, { once: true });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setup, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
    (() => {
      const content = document.querySelector('.our-story-page .rte');
      if (!content) return;

      const paragraphs = Array.from(content.querySelectorAll('p'));

      const pullQuote = paragraphs.find((p) =>
        p.textContent.includes('RIPL is movement, and you are RIPL.')
      );
      if (pullQuote) {
        pullQuote.classList.add('our-story-pull-quote');
      }

      const tagline = paragraphs.find((p) =>
        p.textContent.includes("Movement Is Progress isn't a tagline")
      );
      if (tagline && !tagline.querySelector('.our-story-accent')) {
        const walker = document.createTreeWalker(tagline, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const idx = node.textContent.indexOf('Movement Is Progress');
          if (idx === -1) continue;

          const before = node.textContent.slice(0, idx);
          const match = node.textContent.slice(idx, idx + 'Movement Is Progress'.length);
          const after = node.textContent.slice(idx + 'Movement Is Progress'.length);

          const span = document.createElement('span');
          span.className = 'our-story-accent';
          span.textContent = match;

          node.replaceWith(document.createTextNode(before), span, document.createTextNode(after));
          break;
        }
      }

      const eyebrowLabels = ['Fit First.', 'Fashion Forward.', 'Community Led.'];
      const strongEls = Array.from(content.querySelectorAll('strong'));

      eyebrowLabels.forEach((label, index) => {
        const strongEl = strongEls.find((el) => el.textContent.trim() === label);
        if (!strongEl) return;

        const paragraph = strongEl.closest('p');
        if (!paragraph || !paragraph.parentNode) return;

        const alreadyTagged = paragraph.previousElementSibling?.classList?.contains('our-story-eyebrow');
        if (alreadyTagged) return;

        const eyebrow = document.createElement('div');
        eyebrow.className = 'our-story-eyebrow';
        eyebrow.textContent = String(index + 1).padStart(2, '0');
        paragraph.parentNode.insertBefore(eyebrow, paragraph);
      });
    })();

  } catch(e) { console.error(e); }
})();
})();
